import { getSierraSchematicTree, getSierraSchematicRootComponents, genericSierraSchematicTree, getSierraSchematicLog, updateSierraSchematicRootComponents, updateSierraSchematicConfig, getSierraSchematicConfig } from "../../api/sierra";
import apiProcess from "../../api/utility";

function getSchematicTree(verificationId, pcbId) {
  return apiProcess(getSierraSchematicTree, { verificationId, pcbId }, false, false, true)
}

function genericSchematicTree({ verificationId, roots, forceReGenerate, mode }) {
  return apiProcess(genericSierraSchematicTree, { verificationId, roots, forceReGenerate, mode })
}

function getSchematicTreeLog({ verificationId, pcbId }) {
  return apiProcess(getSierraSchematicLog, { verificationId, pcbId })
}

function getSchematicRootComponents(verificationId) {
  return apiProcess(getSierraSchematicRootComponents, verificationId)
}

function updateSchematicRootComponents({ verificationId, roots }) {
  return apiProcess(updateSierraSchematicRootComponents, { verificationId, roots })
}

function getSchematicConfig(verificationId) {
  return apiProcess(getSierraSchematicConfig, verificationId);
}

function saveSchematicConfig({ schematicConfig, verificationId }) {
  return apiProcess(updateSierraSchematicConfig, { schematicConfig, verificationId })
}

export {
  getSchematicTree,
  getSchematicRootComponents,
  genericSchematicTree,
  getSchematicTreeLog,
  updateSchematicRootComponents,
  saveSchematicConfig,
  getSchematicConfig
}